export default __webpack_public_path__ + "static/media/about-image-02.a1b98175.svg";